import axiosInstance from './axios';
import { apiBaseURL } from 'config/axios';
import Utils from 'services/Utils';

const entityApiRoute = 'tabgens';

export interface TabGen {
  PDF_DESINFECCION_GBA_DROGAS_UTILIZADAS: string;
  PDF_DESINFECCION_COVID_DROGAS_UTILIZADAS: string;
}

const updateEntity = async (entity: TabGen) => {
  const url = `${apiBaseURL}/${entityApiRoute}`;
  await axiosInstance.patch(url, entity);
}

const fetchOne = async (id: string): Promise<TabGen | undefined> => {
  const url = `${apiBaseURL}/${entityApiRoute}/${id}`;
  try {
    const response = await axiosInstance.get(url);
    let entity = response.data?.result;
    entity = Utils.removeNullValues(entity);
    return entity;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error("No se encontraron datos con el ID proporcionado");
    }
    throw new Error("Ocurrio un error al obtener el dato. " + error.message);
  }
}

const fetchAll = async () => {
  const url = `${apiBaseURL}/${entityApiRoute}`;
  const response = await axiosInstance.get(url);
  const result: TabGen = response.data?.result;
  return result;
}

export default {
  updateEntity,
  fetchOne,
  fetchAll
}
